export default "__VITE_ASSET__DeLW3yAi__"